import React from 'react';
import { arrowRIcon } from '../../static/svgs';

export default function ProfileSectionCard({ title, icon, onClick, badge = 0, iconClassName = '' }) {
  return <div className="company-picker-item">
    <button type="button" className="company-picker-main-btn manrope-bold" onClick={onClick}>
      <div className="company-picker-main-top">
        <span className="profile-hub-item-label">
          <span className={`profile-hub-item-icon ${iconClassName}`} aria-hidden="true">{icon}</span>
          <span className="company-picker-name">{title}</span>
        </span>
        <span className="company-picker-trailing">
          {badge > 0 && <span className="company-picker-badge" aria-label={`Непрочитанных: ${badge}`}>{badge}</span>}
          {arrowRIcon}
        </span>
      </div>
    </button>
  </div>;
}
